export default __webpack_public_path__ + "static/media/ill-kyc-verification.640b35e1.svg";